import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { routesConfig } from "./routesConfig";
import PageTransition from "../animations/PageTransition";

function AnimatedRoutes() {
    const location = useLocation();

    return (
        <>
            <Routes
                location={location} 
                key={location.pathname}
            >
                {routesConfig.map(({ path, element }) => (
                    <Route
                        key={path}
                        path={path}
                        element={element}
                    />
                ))}
            </Routes>
        </>
    );
}

export default AnimatedRoutes;
